.emptyCell {
  text-align: center;
}

.emptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px 16px;
  color: var(--tuna-palette-text-secondary);
}

.emptyIcon {
  opacity: 0.5;
}
